import type React from 'react';
import { Button } from '../../core/Button';
import styles from './ProjectGridItem.module.css';

interface ProjectGridItemProps {
  name?: string;
  createdAt?: string;
  isAddButton?: boolean;
  loading?: boolean;
  onClick: () => void;
}

export const ProjectGridItem: React.FC<ProjectGridItemProps> = ({
  name,
  createdAt,
  isAddButton = false,
  loading = false,
  onClick,
}) => {
  if (isAddButton) {
    return (
      <Button variant="ghost" className={styles.addItem} onClick={onClick}>
        <div className={styles.addContent}>
          <div className={styles.addIcon}>+</div>
          <span className={styles.addText}>Create New Project</span>
        </div>
      </Button>
    );
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <button className={styles.projectItem} onClick={onClick} disabled={loading}>
      <div className={styles.projectContent}>
        {loading ? (
          <>
            <div className={styles.skeletonName}></div>
            <div className={styles.skeletonDate}></div>
          </>
        ) : (
          <>
            <h3 className={styles.projectName}>{name}</h3>
            <p className={styles.projectDate}>
              {createdAt ? formatDate(createdAt) : ''}
            </p>
          </>
        )}
      </div>
    </button>
  );
};
